<template>
  <div class="word-cell">
    <div v-for="(metrics, word) in words" :key="word" class="word-line">
      <span class="word-name" @click="onClick(word)">{{ word }}</span>; {{ format(metrics) }}
    </div>
    <div v-if="isEmpty" class="word-empty">—</div>
  </div>
</template>

<script>
import { formatMetrics } from '@/utils/wordStat';

export default {
  name: 'WordCell',
  props: {
    params: { type: Object, required: true },
  },
  computed: {
    words() {
      return this.params.value || {};
    },
    isEmpty() {
      return Object.keys(this.words).length === 0;
    },
  },
  methods: {
    format(metrics) {
      return formatMetrics(metrics);
    },
    onClick(word) {
      const context = this.params.context;
      if (context && typeof context.onWordClick === 'function') {
        context.onWordClick(word, this.params.data);
      }
    },
  },
};
</script>

<style scoped>
.word-cell { line-height: 1.4; }
.word-line { white-space: normal; }
.word-name { font-weight: 600; cursor: pointer; text-decoration: underline dotted; }
.word-name:hover { color: #0d6efd; }
.word-empty { color: #999; }
</style>
